// extracted by mini-css-extract-plugin
export default {"listItem":"style_listItem__I8UoD","leftPart":"style_leftPart__ruygQ","box":"style_box__N0tvJ","rightPart":"style_rightPart__bK047"};